import { stores } from '@stores'
import { cloneDeep, filter } from 'lodash'
import { action, computed, observable } from 'mobx'
import { GROUP_SORT_DATA, GROUP_UPDATE_HANDLERES } from '../constants/CNFGroupByConstants'
import { getChannelName } from '@utils/get-channel-name'

const DEFAULT_EMPTY_GROUP = {
  id: '',
  sortId: GROUP_SORT_DATA[0].sortId
}

export class CNFGroupByUIStore {
  @observable addedGroupByAttributes = []
  @observable groupByAttributes = []

  @computed get isCustomGroupingApplied() {
    return !!(
      this.addedGroupByAttributes.length &&
      this.addedGroupByAttributes.some(item => item?.id)
    )
  }

  @computed get maxGroupByAttributeRows() {
    const {
      productConfiguration: { maxGroupByAttributeRows }
    } = stores
    return maxGroupByAttributeRows
  }

  @action
  setGroupByAttributes = viewName => {
    const {
      nav: {
        queryParams: { clientType }
      },
      productConfiguration: { getActionAttributes }
    } = stores

    const groupByAttributes = getActionAttributes(
      'groupBy',
      getChannelName(clientType),
      viewName
    )
    const allowedGroupByAttributes = filter(
      groupByAttributes,
      attribute => attribute?.isDimension
    )
    this.groupByAttributes = [...allowedGroupByAttributes]
  }

  @action
  applyGroupByOptions = (flag, obj) => {
    switch (flag) {
      case GROUP_UPDATE_HANDLERES.ATTRIBUTE:
        return this.handleGroupAttributeChange(obj)
      case GROUP_UPDATE_HANDLERES.SORT:
        return this.handleGroupSortChange(obj)
      case GROUP_UPDATE_HANDLERES.DRAG:
        return this.onDragRowGroup(obj)
      case GROUP_UPDATE_HANDLERES.REMOVE_GROUP:
        return this.onRemoveGroup(obj)
      case GROUP_UPDATE_HANDLERES.CLEAR_ALL:
        return this.onClearGroups()
    }
    return false
  }

  @action
  handleGroupAttributeChange = ({ id, index }) => {
    const data = cloneDeep(this.addedGroupByAttributes)
    data[index] = { ...data[index], id }
    this.addedGroupByAttributes = data
    return true
  }

  @action handleGroupSortChange = ({ sortId, index }) => {
    const data = cloneDeep(this.addedGroupByAttributes)
    data[index] = { ...data[index], sortId }
    this.addedGroupByAttributes = data
    return !!data[index]?.id
  }

  @action onDragRowGroup = ({ draggedItem, index }) => {
    const tempValues = cloneDeep(this.addedGroupByAttributes)
    const isOrderChanged = draggedItem.index !== index
    const droppedItem = tempValues.splice(draggedItem.index, 1)[0]
    tempValues.splice(index, 0, droppedItem)
    this.addedGroupByAttributes = tempValues
    if (isOrderChanged) {
      return true
    }
    return false
  }

  @action onRemoveGroup = ({ index }) => {
    let temp = cloneDeep(this.addedGroupByAttributes)
    temp = filter(temp, (ele, i) => index !== i)
    this.addedGroupByAttributes = temp
    return true
  }

  @action onClearGroups = () => {
    this.addedGroupByAttributes = []
    return true
  }

  @action
  addNewGroup = () => {
    const temp = cloneDeep(this.addedGroupByAttributes)
    temp.push({ ...DEFAULT_EMPTY_GROUP })
    this.addedGroupByAttributes = temp
  }

  @action
  resetAllGroupBy = () => {
    this.addedGroupByAttributes = []
    this.groupByAttributes = []
  }
}
